<div class="form-main-wrapper" [formGroup]="parentForm">
    <input #checked type="hidden" [formControlName]="controlName">
    <div class="search-container"
        [appPanelTrigger]="listPanel"
        #listTrigger="appPanelTrigger"
        (opened)="onListOpened(listTrigger)"
        (closed)="onListClosed()">
        <mat-form-field>
            <mat-label>{{label | translate}}</mat-label>
            <mat-icon *ngIf="showSearchIcon" matPrefix class="search-icon" svgIcon="search"></mat-icon>
            <input type="text" #searchInput matInput [formControl]="searchControl"
                [style.text-overflow]="'ellipsis'"
                (focus)="listTrigger.open()"
                (click)="listTrigger.open()"
                (blur)="onSearchBlur()"
                (keydown.escape)="onEscapeWhenClosed()"
                (input)="onSearchChange(searchInput.value, listTrigger)">
            <mat-error *ngIf="controlError() as error">{{error | translate}}</mat-error>
        </mat-form-field>
    </div>
</div>

<ng-template #listPanel>
    <!-- Lista stoi w nakładce, poza elementem komponentu, więc zdarzenia myszy podajemy gospodarzowi stąd. -->
    <div class="list-panel" (contextmenu)="panelContextMenu.emit($event)">
        <app-option-check-list
            [options]="options"
            [filter]="key"
            [value]="currentValue()"
            (valueChange)="setValue($event)">
        </app-option-check-list>
    </div>
</ng-template>
